import "./login.module.css";

import API from "../../../servicos/API";

import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";

import { Campo } from "../../../componentes/form/campo";
import { Spinner } from "../../../componentes/Spinner";

import packinfo from "../../../../package.json";

import { ContextoGeral } from "../../../contextos/ContextoGeral";
import { configAnim } from "../../../servicos/config/configAnim";
import ProfissionalAPI from "../../../servicos/ProfissionalAPI";

import { Alert, Backdrop, Button } from "@mui/material";
import mensagemApp from "../../../servicos/config/MensagemApp.js";
import { identificarDispositivoNativo } from "../../../servicos/dispositivo";

import { MdClose } from "react-icons/md";
import TopoMenu from "../../../componentes/gerais/TopoMenu";
import { copy, print } from "../../../servicos/Uteis.js";
import axios from "axios";

// OBTER O IMEI
export function Login() {
	document.title = "Aplicativo do Profissional"

	const [loading, setLoading] = useState(false)
	const [show, setShow] = useState([false, null])
	const [auth, setAuth] = useState(" ")
	const { dados, setDados } = useContext(ContextoGeral)
	const [msg, setMsg] = useState("")

	const [linkTermos, setLinkTermos] = useState("")
	const [logado, setLogado] = useState(false)
	const [statusLogado, setStatusLogado] = useState("")

	const [email, setEmail] = useState("")
	const [senha, setSenha] = useState("")

	const handleEmail = (event) => {
		setEmail(event.target.value);
	}

	const handleSenha = (event) => {
		setSenha(event.target.value);
	}

	async function termoDeUso() {
		let retorno = await ProfissionalAPI.buscarTermosUso(dados)

		if (retorno?.resultado) {
			if (retorno.dados != "" && retorno.dados.link != "") {
				setLinkTermos(retorno.dados.link);
			}
		}
	}

	function isIOSBridge() {
		return identificarDispositivoNativo() === "iOS";
	}

	async function recoverFirebaseTokenIOS(maxMs = 8000, stepMs = 400) {
		// 1) tenta cache síncrono
		let token = window.AndroidInterface?.recoverIdFirebase?.() || "";
		if (token && token.trim() !== "") return token.trim();

		// 2) tenta bridge assíncrona real (StorageManager no nativo)
		if (typeof window.AndroidInterface?.recoverIdFirebaseAsync === "function") {
			const start = Date.now();
			while (Date.now() - start < maxMs) {
				try {
					const t = await window.AndroidInterface.recoverIdFirebaseAsync();
					if (t && String(t).trim() !== "") {
						// mantém cache JS consistente
						if (window._updateNativeCache) window._updateNativeCache("idFirebase", String(t).trim());
						return String(t).trim();
					}
				} catch (e) {
					// segue tentando
				}
				await new Promise(r => setTimeout(r, stepMs));
			}
		}

		return "";
	}

	async function definirToken(res) {
		let versionApp = window.AndroidInterface?.recoverVersion() ?? 100.39

		let jsonDados = {
			...dados,
			avaliacaoProf: res.dados.avaliacaoProf,
			idProf: res.dados.id,
			token: res.dados.token,
			nome: res.dados.nome,
			email: res.dados.email,
			status: res.dados.status,
			foto: res.dados.foto,
			statusOnline: false,
		}

		if (res.dados.status == "OL")
			jsonDados.statusOnline = true

		if (res.dados.codigo !== undefined)
			jsonDados.codigo = res.dados.codigo

		if (res.dados.tipoVeiculo !== undefined && res.dados.tipoVeiculo !== null)
			jsonDados.tipoVeiculo = res.dados.tipoVeiculo

		if (res.dados.siglaTipoVeiculo !== undefined && res.dados.siglaTipoVeiculo !== null)
			jsonDados.siglaTipoVeiculo = res.dados.siglaTipoVeiculo

		if (res.dados.iconeTipoVeiculo !== undefined && res.dados.iconeTipoVeiculo !== null)
			jsonDados.iconeTipoVeiculo = res.dados.iconeTipoVeiculo

		let tokenJWT = await API({
			url: "/gerarTokenJWT",
			method: "POST",
			data: JSON.stringify(jsonDados),
			headers: {
				"Content-Type": "application/json",
			},
			timeout: 2000,
		}).then(res => res.data.token).catch(rej => rej)

		if (tokenJWT !== "" && window.AndroidInterface)
			window.AndroidInterface.saveToken(tokenJWT)

		const respToken = await axios(`https://${dados.dominio}/sem/v1/rotas.php/modulo-chat-profissional/buscarIdConfig/`, {
			params: {
				dominio: dados.dominio,
				codProf: res.dados.id ?? 0
			},
			headers: {
				"content-type": "application/json",
				"Authorization": "Bearer " + res.dados.token
			}
		}).then(r => r.data).catch(r => r)

		if (respToken)
			if (respToken?.status == 200)
				jsonDados.idConfig = respToken.dados
			else console.error("houve um problema ao buscar idconfig");
		else console.error("Erro ao buscar idConfig")

		setDados(jsonDados)

		if (window.AndroidInterface)
			window.AndroidInterface.stopBackgroundLocation()

		if (!res.dados.termoUso || versionApp <= 100.39) {
			setLogado(true)
			setStatusLogado(res.dados.ativo)
		} else {
			try {
				if (window.AndroidInterface) {
					setAuth(<></>)
					window.AndroidInterface.showTermoApp(res.dados.id)
				}
			} catch (e) { }
		}
	}

	async function logar() {
		console.log("[LOGIN] click");
		const dispositivo = identificarDispositivoNativo()
		setLoading(true)
		setAuth(<div className="mt-3">
			<Spinner />
		</div>)

		// iOS-only: após limpar cache, pode haver corrida do idFirebase no cache JS.
		if (isIOSBridge()) {
			const tokenIOS = await recoverFirebaseTokenIOS(8000, 400);
			console.log("[LOGIN][iOS] idFirebase apos fallback:", tokenIOS ? `${tokenIOS.slice(0, 20)}...` : "(vazio)");

			if (!tokenIOS) {
				setAuth(
					<Alert severity="warning" className="textCenter mt-3">
						Inicializando notificações. Aguarde alguns segundos e tente novamente.
					</Alert>
				);
				setLoading(false);
				return;
			}
		}

		const hasAI = !!window.AndroidInterface;
		const idFirebase = hasAI ? window.AndroidInterface.recoverIdFirebase() : "";
		console.log("[LOGIN] pre-check", {
			dominio: dados?.dominio,
			emailLen: (email || "").length,
			senhaLen: (senha || "").length,
			hasAndroidInterface: hasAI,
			dispositivo: dispositivo,
			idFirebase: idFirebase ? `${idFirebase.slice(0, 18)}...` : "(vazio)"
		});

		let resposta = await ProfissionalAPI.logar(dados, email, senha, dispositivo)
		console.log("[LOGIN] resposta logar", {
			resultado: resposta?.resultado,
			aux: resposta?.aux,
			codigo: resposta?.codigo,
			mensagem: resposta?.mensagem
		});
		
		if (resposta.resultado) {
			if (window.AndroidInterface) {
				try {
					const ver = await window.AndroidInterface.versaoSdkAndroid()
					const info = JSON.parse(await window.AndroidInterface.retornaMarcaModelo())

					const resMD = await ProfissionalAPI.salvarDadosAndroid({
						dominio: dados.dominio,
						avaliacaoProf: resposta.dados.avaliacaoProf,
						idProf: resposta.dados.id,
						androidAPI: ver,
						marca: info.marca,
						modelo: info.modelo
					})

				} catch {
					console.error("Obter info. do aparelho não está disponível nesta versão")
				}
			}
			definirToken(resposta);
		} else {
			if (resposta.aux == "usuarioInativo") {
				definirToken(resposta);
			} else {
				if (resposta?.mensagem) {
					setAuth(
						<Alert severity="error" className="textCenter mt-3">
							{resposta.mensagem}
						</Alert>
					);
				} else {
					setAuth(
						<Alert severity="error" className="textCenter mt-3">
							{mensagemApp.msgErroApi}
						</Alert>
					);
				}
			}
		}

		setTimeout(() => setLoading(false), 800)
	}

	useEffect(() => {
		if (!!window.AndroidInterface) {
			let emailSalvo = window.AndroidInterface.recoverEmail()
			let senhaSalva = ""
			try {
				senhaSalva = window.AndroidInterface.recoverPassword()
			} catch {
				console.error("Não foi possível recuperar e-mail e senha neste aplicativo")
			}

			if (emailSalvo && emailSalvo !== "") {
				setEmail(emailSalvo)
			}

			if (senhaSalva && senhaSalva !== "") {
				setSenha(senhaSalva)
			}
		}

		termoDeUso()
	}, [])

	useEffect(() => {
		if (logado) {
			setAuth(() => {
				if (!!window.AndroidInterface) {
					window.AndroidInterface.saveEmail(email)
					try {
						window.AndroidInterface.savePassword(senha)
					} catch (e) {
						console.error("Não foi possível salvar e-mail e senha neste aplicativo")
					}
				}

				return (
					<>
						<Alert key={"success"} severity="success" className="textCenter mt-3">
							{mensagemApp.msgSucessoLogar}
							{statusLogado === "N" ? <Navigate to="/app/cadastro/pos" /> : <Navigate to="/app/home" />}
						</Alert>
						<div className="mt-3">
							<Spinner />
						</div>
					</>
				);
			});
		}
	}, [logado])

	return <>
		<motion.div
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
		>
			<>
				<div className="h-lvh flex flex-col justify-between">
					<div>
						<TopoMenu voltar="/home" titulo="LOGIN" />
						<div className="mx-3 flex flex-col justify-between">
							<h3 className="textCenter">Que bom ter você aqui!</h3>

							<form>
								<div className="mt-3">
									<Campo
										id="nome"
										label="E-mail ou nome de usuário"
										placeholder=" "
										tipo="text"
										autoComplete="email"
										value={email}
										onChange={handleEmail}
									/>
								</div>
								<div className="mt-3">
									<Campo
										id="senha"
										label="Senha"
										placeholder=" "
										tipo="password"
										value={senha}
										onChange={handleSenha}
									/>
								</div>
							</form>
							<div className="textRight mt1">
								<Link to="/recuperarSenha">Esqueci a senha</Link>
							</div>
							<div>{msg}</div>
							<motion.div
								key={auth}
								initial={{
									opacity: 0,
								}}
								animate={{
									opacity: 1,
								}}
								exit={{
									opacity: 0,
								}}
								transition={{ ease: "easeInOut", duration: 0.2 }}
							>
								{auth}
							</motion.div>
						</div>
					</div>
					<div className="w-full flex flex-col mb-3 px-3">
						<div className="text-center mb-2 opacity-75 small">
							<div>
								Versão {!!window.AndroidInterface && window.AndroidInterface.recoverVersion()} •{" "}
								{packinfo.version}
							</div>
						</div>
						<Button variant="contained" onClick={logar} disabled={loading}>ENTRAR</Button>
						<div className="flex justify-between mt-3">
							<Button size="small" onClick={() => setShow([true, "privacidade"])}><small>Política de privacidade</small></Button>
							{linkTermos && (
								<Button size="small" onClick={() => setShow([true, "uso"])}><small>Termos de uso</small></Button>
							)}
						</div>
					</div>
				</div>
			</>
		</motion.div>

		<Backdrop open={show[0]} sx={{ zIndex: 2000 }}>
			<div style={{ height: "var(--app-vh)", width: "100%", backgroundColor: "white", zIndex: 2000 }}>
				<div className="flex justify-end p-3">
					<MdClose size={32} onClick={() => setShow([false, null])} />
				</div>
				<iframe
					style={{ height: "calc(100% - 5rem)", width: "100%" }}
					src={show[1] == "uso"
						? `${linkTermos}?exibirBtn=false`
						: "https://" + dados.dominio + "/politicaPrivacidadeAndroid"}
					title="política de privacidade"
				/>
			</div>
		</Backdrop>
	</>
}
